import type { ApiError } from '@festina/life-general-types/life'
import type { Severity } from '@festina-life/ui/feedback'
import type { useTranslate } from '@festina-life/ui/hooks'

import { isValidationErrorMessage } from '../../utility/errors'

export const errorToSeverity = (error: unknown): Severity => {
  if (!isApiError(error)) {
    return 'error'
  }

  const severityMapping: Record<number, Severity> = {
    403: 'info',
  }

  return severityMapping[error.status] ?? 'error'
}

export const isApiError = (error: unknown): error is ApiError =>
  typeof error === 'object' &&
  error !== null &&
  'status' in error &&
  'body' in error

export const toTitle = (
  error: unknown,
  translate: ReturnType<typeof useTranslate>,
) => {
  if (isValidationErrorMessage(error)) {
    return translate('error.validation.message')
  }
  if (!isApiError(error)) {
    return translate('error.fallback.message')
  }

  return (
    {
      400: translate('error.400.message'),
      401: translate('error.401.message'),
      403: translate('error.403.message'),
      404: translate('error.404.message'),
      408: translate('error.408.message'),
    }[error.status] ?? translate('error.fallback.message')
  )
}
